import { ReactNode } from 'react';
import styles from './Modal.module.scss';

interface ModalTitleProps {
  children: ReactNode;
  classNames?: any;
}

const ModalTitle = ({ children, classNames }: ModalTitleProps) => {
  return <div className={`${styles.modal__title} ${classNames}`}>{children}</div>;
};

export default ModalTitle;
